import request from "@/utils/request";

const chapterAudio = (bookId, chapterId) => request
  .get(`/api/books/${bookId}/chapters/${chapterId}/audio`, { token: true })
  .then(response => response.url);

const sample = bookSlug => request
  .get("/api/books/sample_url/", {
    params: { slug: bookSlug },
    token: true
  });

const bookGalleryPartial = (categorySlug) => request
  .get("/api/books/books_in_brief_page", {
    params: {
      // eslint-disable-next-line camelcase
      category_slug: categorySlug
    }
  })
  .then(response => response.top_books_section);

const trending = ({ categorySlug, limit }) => {
  const params = { limit };
  if (categorySlug) {
    params["category_slug"] = categorySlug;
  }
  return request
    .get("/api/books/trending", { params });
};

const latest = ({ categorySlug, limit }) => {
  const params = { limit };
  if (categorySlug) {
    params["category_slug"] = categorySlug;
  }
  return request
    .get("/api/books/latest", { params });
};

const index = (bookId) => {
  return request
    .get(`/api/books/${bookId}/chapters`, { token: true });
};

const onboarding = (categorySlugs, locale, numberOfBooksToReturn) => {
  return request
    .get(
      "/api/books/onboarding", { params: { category_slugs: categorySlugs, number_of_books_to_return: numberOfBooksToReturn, locale }, token: true }); //eslint-disable-line camelcase
};

const chapter = ({ bookId, chapterId }) => {
  return request
    .get(`/api/books/${bookId}/chapters/${chapterId}`, { token: true });
};

export default {
  chapterAudio,
  sample,
  bookGalleryPartial,
  trending,
  latest,
  index,
  chapter,
  onboarding
};
